import { downloadCSV } from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';

const exporter = typesPlan =>
{
  const data = typesPlan.map(typePlan => (
  {
    id: typePlan.id,
    nome: typePlan.name,
    acesso_audio: typePlan.has_audio ? 'Sim' : 'Não',
    acesso_texto: typePlan.has_text ? 'Sim' : 'Não',
    acesso_video: typePlan.has_video ? 'Sim' : 'Não',
    categorias_midia: Array.isArray(typePlan.categories_media) ? typePlan.categories_media.map(categoryMedia => categoryMedia.name).join(', ') : '',
    criado_em: typePlan.created_at_format
  }));
  const csv = convertToCSV(
  {
      data,
      fields: ['id', 'nome', 'acesso_audio', 'acesso_texto', 'acesso_video', 'categorias_midia', 'criado_em']
  });
  downloadCSV(csv, 'types-plan');
}

export default exporter;
